<template>
  <!-- TODO: Testcode needs to be completed -->
  <section v-if="list" class="past-orders" v-htmlclass='{"past-orders-open": value}'>
    <div class="wrapper wrapper--tablet">
      <div class="control">
        <div class="control__section control__section--past">
          <h2>Past Orders</h2>
          <div
            class="control__grid control__scroll"
          >
            <OrderBox
              v-for="item in list"
              :key="item.id"
              :order="item"
              @click="$emit('changestate', item)"
            />
          </div>
        </div>
        <button
          type="button"
          class="control__past-orders-button"
          @click="onCloseButton"
        >Back to current Orders</button>
      </div>
    </div>
  </section>
</template>

<script>
import OrderBox from '@num/components/OrderBox'

export default {
  props: {
    list: {
      type: Array
    },
    value: {
      required: true
    },
  },
  components: {
    OrderBox
  },
  methods: {
    onCloseButton() {
      this.$emit("input", false);
    }
  }
}
</script>

<style>
</style>
